import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const PoolCardStyled = styled(Link)<{ disabled?: boolean }>`
  ${({ disabled }) => disabled && 'pointer-events: none;'}

  position: relative;
  cursor: pointer;
  background: ${({ theme }) => theme.bg1};
  display: flex;
  flex-direction: column;
  border-radius: 16px;
  padding: 20px;
  width: 100%;
  transition: all 300ms;
  text-decoration: none;
  color: white;
  min-height: 184px;

  &:hover {
    background: ${({ theme }) => theme.bg2};
  }

  .poolCard__tag {
    position: absolute;
    right: 12px;
    top: 12px;
  }

  .poolCard__header {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    margin-bottom: 4px;

    h2 {
      font-size: 18px;
      font-weight: 600;
      margin-left: 10px;
      font-family: 'unbounded';
    }
  }
  .poolCard__subheader {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;

    img svg {
      width: 14px;
      height: 14px;
    }

    span {
      font-size: 12px;
      font-weight: 300;
      color: #c3c5cb;
    }
  }
`

export const EntriesStyled = styled.div`
  display: grid;
  grid-template-columns: 1.2fr 1fr;
  row-gap: 0.75rem;
  margin-top: 8px;
`
